import './App.css';
import { Route, Switch, BrowserRouter } from 'react-router-dom';
import ChatRoom from './components/home';
import AuthProvider from './context/AuthProvider';
import Login from './components/login/index';
function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Switch>
          <Route component={Login} path='/login' />
          <Route component={ChatRoom} path='/' />
        </Switch>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;